export default __webpack_public_path__ + "static/media/os.2607a907.jpeg";